import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class OperationsRoute extends Route {
  @service router;

  beforeModel(/* transition */) {
    this.router.transitionTo('settings.teams'); // Implicitly aborts the on-going transition.
  }
}
